import { CatsRecordTypeEnum } from '@shared-enums/cats.enum';

import { CatsRecord } from './catsRecord';
import { Employee } from './employee';
import { NonbillableCodes } from './nonbillable';
import { ITimesheetDate } from './timesheetHandler';

export class NonbillableCatsRecord extends CatsRecord {
  public get __AbsAttTypeDescription(): string {
    return this.nonbillableCodes.getDescription(this.AbsAttType);
  }

  constructor(private readonly nonbillableCodes: NonbillableCodes) {
    super('non');
  }

  public getRequiredObject(employee: Employee, extDocument: string, date?: ITimesheetDate): this {
    if (date) this.Workdate = date.unix;
    else this.Workdate = employee.focusedDay?.unix ?? null; //get the moment object for the focused day, convert it to odata friendly value.
    this.Extdocumentno = extDocument;
    this.Employeenumber = employee.EmpId;
    this.Catshours = 0;
    this.AbsAttType = '';
    this.ZempCreatedBy = employee.datahub.user.getEmpId();
    this.SendCctr = employee.CostCenter;
    this.Zrecordtype = CatsRecordTypeEnum.EmployeeNonBillable;
    return this;
  }
}
